import { useUserInfo } from "../../context/user";

import "./style.css";
import { useHttp } from "../../common/hooks/useHttp";
import env from "../../config/env";
import { useEffect, useState } from "react";
import { Navbar } from "../../components/Navbar";

const Dashboard = () => {
  const BASE_URL = `${env.API_URL}/v1`;
  const location = useUserInfo();
  const agencyData = useUserInfo()[11]
  const { sendRequest: getEventData } = useHttp();
  const [totalMatchLocationfromchat, setTotalMatchLocationfromchat] = useState(0)
  const getdata = () => {
    const location_id = location
    getEventData(
      {
        url: `${BASE_URL}/chat/get_data_by_location/${location_id._id}`,
        method: "GET",
        payload: {},
      },
      async (response: any) => {
        setTotalMatchLocationfromchat(response.data.length);
      }
    );
  }
  useEffect(() => {
    getdata()
  }, [])

  return (
    <>
      <div className="p-5 m-auto position-relative extraPadding" style={{ background: agencyData?.Customization?.body_bg ? agencyData?.Customization?.body_bg : '#fff', height: '100vh' }}>
        <Navbar />
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">No of Chats</div>
              <div className="statistic" >
                <div className="statistic-icon">{totalMatchLocationfromchat}</div>
                <div className="statistic-value">Total Chats</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total API Calls</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value"> API Calls</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Amount Spend</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Spend</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Post Generated</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Post Generated</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Remaining Balance</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Remaining Balance</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Users</div>
              <div className="statistic" >
                <div className="statistic-icon">0 </div>
                <div className="statistic-value">Users</div>
              </div>
            </div>
          </div>


        </div>

      </div>
    </>
  )
}
export default Dashboard